'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2016/9/5.
                                          * 优惠消息
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _preferentialMessage = require('redux/modules/preferentialMessage');

var preferentialMessageActions = _interopRequireWildcard(_preferentialMessage);

var _reduxAsyncConnect = require('redux-async-connect');

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { push } from 'react-router-redux';
// import { Link } from 'react-router';

var PreferentialMessage = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var location = _ref.location;

    var promises = [];
    promises.push(dispatch(preferentialMessageActions.load(location.query)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.preferentialMessage.data,
    dataError: state.preferentialMessage.error
  };
}, (0, _extends3.default)({}, preferentialMessageActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PreferentialMessage, _Component);

  function PreferentialMessage() {
    (0, _classCallCheck3.default)(this, PreferentialMessage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PreferentialMessage).call(this));

    _this.state = {
      orderBy: 'ALL',
      discountOrder: [{
        orderType: 'ALL',
        orderDescribe: '全部'
      }, {
        orderType: 'READ',
        orderDescribe: '已读'
      }, {
        orderType: 'UNREAD',
        orderDescribe: '未读'
      }, {
        orderType: 'DELETED',
        orderDescribe: '已删除'
      }, {
        orderType: 'DISCOUNTINFORMATION',
        orderDescribe: '优惠信息'
      }, {
        orderType: 'DISCOUNTS',
        orderDescribe: '打折信息'
      }, {
        orderType: 'PROMOTIONALINFORMATION',
        orderDescribe: '促销信息'
      }]
    };
    return _this;
  }

  (0, _createClass3.default)(PreferentialMessage, [{
    key: 'onItemClick',
    value: function onItemClick(val) {
      var load = this.props.load;

      if (load) {
        load(val);
      }
    }
  }, {
    key: 'onOrderByItemClick',
    value: function onOrderByItemClick(item) {
      if (item !== this.state.orderBy) {
        this.setState({
          orderBy: item
        });
      }
    }
  }, {
    key: 'onSearch',
    value: function onSearch() {
      var load = this.props.load;

      var val = this.refs.searchInput;
      if (load) {
        var filter = '';
        if (val && val !== '') {
          filter = { FindValue: val };
        }
        load(filter);
      }
    }
  }, {
    key: 'handChange',
    value: function handChange() {
      // console.log(event.target.value); event
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.data;
      var _state = this.state;
      var orderBy = _state.orderBy;
      var discountOrder = _state.discountOrder;

      var sou = require('./shc.png');
      var styles = require('./PreferentialMessage.scss');

      var preferentialMessage = data.preferentialMessage;
      var preferentialMessageError = data.preferentialMessageError;

      var preferentialMessageShow = '';

      if (preferentialMessageError) {
        preferentialMessageShow = _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'td',
            null,
            'preferentialMessageError:'
          ),
          _react2.default.createElement(
            'td',
            null,
            preferentialMessageError
          )
        );
      } else {
        preferentialMessageShow = preferentialMessage instanceof Array ? preferentialMessage.map(function (message, index) {
          return _react2.default.createElement(_components.PreferentialMessageComponent, { key: message.id, index: index, message: message });
        }) : '';
      }

      /*
       let options = [];
       if (preferentialMessage.orderByDates instanceof Array) {
       options = preferentialMessage.orderByDateList.map((orderByDate)=><option key={orderByDate.value}
       value={orderByDate.value}>{orderByDate.label || orderByDate.value}</option>);
       }
       options.splice(0, 0, <option key="null" value=""> -- 请选择 -- </option>);
       */
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'ul',
          { className: styles.js_ul },
          discountOrder.map(function (currentOrderInfo, index) {
            return _react2.default.createElement(
              'li',
              { key: 'crowdfunding' + index,
                className: styles.js_li + ' ' + (orderBy === currentOrderInfo.orderType ? styles.border : ''),
                onClick: function onClick() {
                  _this2.onOrderByItemClick(currentOrderInfo.orderType);_this2.onItemClick(currentOrderInfo.orderType);
                } },
              currentOrderInfo.orderDescribe
            );
          })
        ),
        _react2.default.createElement(
          'select',
          { className: styles.selt, onChange: this.handChange.bind(this) },
          _react2.default.createElement(
            'option',
            { value: 'LASTWEEK' },
            '    最近一周'
          ),
          _react2.default.createElement(
            'option',
            { value: 'LASTMONTH' },
            '    最近一个月'
          ),
          _react2.default.createElement(
            'option',
            { value: 'LASTTHREEMONTH' },
            '    最近三个月'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.js_all_sou },
          _react2.default.createElement('input', { type: 'text', ref: 'searchInput', className: styles.input }),
          _react2.default.createElement(
            'div',
            { onClick: this.onSearch.bind(this) },
            _react2.default.createElement('img', { src: sou, alt: '', className: styles.img })
          )
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement('div', { className: styles.bk_zs_link }),
        _react2.default.createElement(
          'table',
          { className: styles.allTable },
          _react2.default.createElement(
            'colgroup',
            null,
            _react2.default.createElement('col', { style: { width: '5%' } }),
            _react2.default.createElement('col', { style: { width: '10%' } }),
            _react2.default.createElement('col', { style: { width: '12%' } }),
            _react2.default.createElement('col', { style: { width: '19%' } }),
            _react2.default.createElement('col', { style: { width: '44%' } }),
            _react2.default.createElement('col', { style: { width: '10%' } })
          ),
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                '选择'
              ),
              _react2.default.createElement(
                'th',
                null,
                '日期'
              ),
              _react2.default.createElement(
                'th',
                null,
                '发件人'
              ),
              _react2.default.createElement(
                'th',
                null,
                '标题'
              ),
              _react2.default.createElement(
                'th',
                null,
                '内容'
              ),
              _react2.default.createElement(
                'th',
                null,
                ' '
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            preferentialMessageShow
          )
        ),
        _react2.default.createElement('div', { className: styles.bk_zs_link }),
        _react2.default.createElement(
          'a',
          { className: styles.quanxuan },
          _react2.default.createElement('i', null),
          _react2.default.createElement(
            'span',
            null,
            '全选'
          )
        ),
        _react2.default.createElement(
          'a',
          { className: styles.rightBtn },
          '删除'
        )
      );
    }
  }]);
  return PreferentialMessage;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object,
  location: _react.PropTypes.object,
  load: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = PreferentialMessage;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PreferentialMessage/PreferentialMessage.js
 ** module id = 1525
 ** module chunks = 0
 **/